<template>
    <div class="systemTree-table">
        <v-card v-for="(row, rowIndex) in rows" :key="rowIndex" class="row-card">
            <v-card-text class="row-card-text">
                <v-row>
                    <v-col cols="12" class="cell-expand cell-label">
                        <span class="txt-header">{{ row.indicatorName }}</span>
                        <v-icon @click="toggleExpand(row)" class="cell-expand-icon">
                            {{ expanded === row.id ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                        </v-icon>
                    </v-col>
                    <v-col v-show="expanded === row.id" cols="12">
                        <v-row>
                            <v-col cols="12" sm="6" class="cell-label">Значение</v-col>
                            <v-col cols="12" sm="6" class="cell-value">
                                {{ row.indicatorValue }}
                            </v-col>
                            <v-col cols="12" sm="6" class="cell-label">Способ получения информации</v-col>
                            <v-col cols="12" sm="6" class="cell-value">
                                {{ getWayNames(row.propertyDGWs) }}
                            </v-col>
                            <v-col v-if="row.propertyMediaLinks.length > 0" cols="12" sm="6" class="cell-label">Файл</v-col>
                            <v-col v-if="row.propertyMediaLinks.length > 0" cols="12" sm="6" class="cell-value">
                                <TaskMediaFiles :files="row.propertyMediaLinks" :maxWidth="mediaMaxWidth" />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <div v-if="load">
            Загрузка...
        </div>
    </div>
</template>

<script>
import TaskMediaFiles from '@/components/TaskMediaFiles.vue';
import './mobileView.scss';

export default {
    props: {
        rows: { type: Array, default: () => [] },
        load: { type: Boolean, default: () => true }
    },
    components: { TaskMediaFiles },
    data: () => ({
        mediaMaxWidth: 0,
        expanded: null
    }),
    methods: {
        toggleExpand(row) {
            this.expanded = this.expanded !== row.id ? row.id : null;
        },
        getWayNames(ways) {
            return ways.map(x => x.dataGetWay.wayName).join(', ');
        }
    },
    created() {
        this.mediaMaxWidth = window.innerWidth - 92;
    }
}
</script>
